import React from 'react';
import NotificationIcon, { EverythingIcon } from './NotificationIcon';
import { FAMILIES } from './notificationTypes';
import { fillFor, T, RADIUS } from './notificationModel';

export const ALL_FAMILY = { key: 'all', label: 'EVERYTHING' };

/** The aside's rows: EVERYTHING then the nine families. */
export const FILTER_ROWS = [ALL_FAMILY, ...FAMILIES];

function icon(f, size) {
  return f.key === 'all'
    ? <EverythingIcon size={size} />
    : <NotificationIcon type={f.key} size={size} badge={false} live={f.key === 'signals' ? true : undefined} />;
}

/**
 * The family filter (handoff §1 "Aside"). ≥ 980 it's the white list with a count pill per
 * row; below that a pill scroller that bleeds to the page edges.
 *
 *   active   the family key ('all' by default)
 *   counts   { [family]: unread } (+ counts.all)
 *   gutter   the page's side padding, so the scroller can bleed past it
 */
export default function FamilyFilter({ active = 'all', counts = {}, onSelect, wide = true, gutter = 16 }) {
  const countFor = (f) => (f.key === 'all' ? counts.all : counts[f.key]) || 0;

  if (wide) {
    return (
      <div data-testid="family-list" style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 8, borderRadius: RADIUS.panel, background: T.white }}>
        {FILTER_ROWS.map((f) => {
          const on = active === f.key;
          const c = countFor(f);
          return (
            <button
              key={f.key}
              type="button"
              onClick={() => onSelect?.(f.key)}
              aria-pressed={on}
              className="pr-family-row"
              style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '6px 12px 6px 6px', border: 0, borderRadius: RADIUS.row,
                background: on ? T.ink : T.white, color: on ? '#fff' : T.ink, fontFamily: 'inherit', textAlign: 'left', cursor: 'pointer',
                transition: 'background-color .2s, color .2s',
              }}
            >
              <span style={{ display: 'flex' }}>{icon(f, 36)}</span>
              <span style={{ flex: 1, minWidth: 0, fontSize: 11, fontWeight: 700, letterSpacing: '.1em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{f.label}</span>
              {c > 0 && (
                <span style={{ minWidth: 20, height: 20, padding: '0 6px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: RADIUS.pill, background: on ? T.live : T.ink, color: '#fff', fontSize: 10, fontWeight: 800 }}>
                  {c}
                </span>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="pr-noscroll" data-testid="family-scroller" style={{ display: 'flex', gap: 6, overflowX: 'auto', scrollbarWidth: 'none', margin: `0 -${gutter}px`, padding: `0 ${gutter}px` }}>
      {FILTER_ROWS.map((f) => {
        const on = active === f.key;
        const c = countFor(f);
        return (
          <button
            key={f.key}
            type="button"
            onClick={() => onSelect?.(f.key)}
            aria-pressed={on}
            style={{
              flexShrink: 0, display: 'flex', alignItems: 'center', gap: 8, height: 40, padding: '0 14px 0 4px', border: '2px solid transparent', borderRadius: RADIUS.pill,
              background: on ? fillFor('on') : T.white, color: on ? '#fff' : T.ink, fontFamily: 'inherit', cursor: 'pointer', boxSizing: 'border-box',
            }}
          >
            <span style={{ display: 'flex' }}>{icon(f, 30)}</span>
            <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.08em', whiteSpace: 'nowrap' }}>{f.label}</span>
            {c > 0 && <span style={{ fontSize: 10, fontWeight: 800, color: on ? T.live : T.grey500 }}>{c}</span>}
          </button>
        );
      })}
    </div>
  );
}
